module.exports = __webpack_public_path__ + "img/thumbnail-placeholder.4a7d0318.png";